import config from 'appConfig';
import locationMarker from 'assets/icons/icon-location-bar-location-marker.svg';
import { debounce } from './miscellaneousServices';
// import { onMarkerChange } from './mockApiService';
let gPlaces = null;
let geocoder = null;
let gMap = null;
let marker = null;
let OK = null;
let upSizedLocationMarker = null;

let initialState = {
  isMapInitialized: false,
  placeId: null,
  sessionToken: null,
  mapNode: null,
  map: null,
  marker: null,
  markerChangedCb: null,
  geoLocationPosition: null,
  // placeId: 'ChIJca7aLrrO5zsRzyW0LfAzQAk', //Prabhadevi
  // placeId: 'ChIJ5aIA-LzO5zsRAktP2ROM60k',  // Amar nagar, worli.
};

export const initializeMap = (coordinates = null, placeId = null) => {
  gPlaces = window.google.maps.places;
  geocoder = window.google.maps.Geocoder;
  gMap = window.google.maps.Map;
  marker = window.google.maps.Marker;
  OK = gPlaces.PlacesServiceStatus.OK;
  upSizedLocationMarker = new window.google.maps.MarkerImage(
    locationMarker,
    null, //* size is determined at runtime */
    null, //* origin is 0,0 */
    null, //* anchor is bottom center of the scaled image */
    new window.google.maps.Size(50, 50)
  );
  initialState = {
    isMapInitialized: true,
    sessionToken: new gPlaces.AutocompleteSessionToken(),
    geoLocationPosition: null,
  };
  if (placeId && !coordinates) setPlace(placeId);
  if (coordinates && !placeId) setGeoLocationPosition(coordinates);
};

export const initializeMapNode = (querySelector, markerChangedCb, markerDragStartCb) => {
  if (!initialState.isMapInitialized) initializeMap();
  return _setMapFromPlaceId(querySelector, markerChangedCb, markerDragStartCb);
};

const _mapOnClick = ({ latLng }) => {
  console.log('Click Lat: ', latLng.lat());
  console.log('Click Lng: ', latLng.lng());
  // initialState.marker && initialState.marker.setPosition(latLng);
  // const geoCoder = new geocoder();
  // geoCoder.geocode({ location: latLng }, function(results, status) {
  //   if (status === OK) {
  //     initialState.markerChangedCb(results[0]);
  //   }
  // });
};
const _onCenterChanged = () => {
  const location = initialState.map.getCenter();
  const geoCoder = new geocoder();
  geoCoder.geocode({ location }, function(results, status) {
    if (status === OK) {
      const address = results[0];
      console.log('Center Lat: ', location.lat());
      console.log('Center Lng: ', location.lng());
      console.log('placeLatitude: ', address?.geometry?.location.lat());
      console.log('placeLongitude: ', address?.geometry?.location.lng());
      address.placeLatitude = address?.geometry?.location.lat();
      address.placeLongitude = address?.geometry?.location.lng();
      address.geometry = address.geometry || {};
      address.geometry.location = location;
      initialState.markerChangedCb(address);
    }
  });
};

const _setMapFromPlaceId = (querySelector, markerChangedCb, markerDragStartCb) => {
  return new Promise((resolve, reject) => {
    const { geoLocationPosition: position } = initialState;
    if (!(initialState.placeId || initialState.geoLocationPosition))
      return reject('placeId not found');
    initialState.mapNode = document.querySelector(querySelector);
    initialState.map = new gMap(initialState.mapNode, {
      zoom: 18,
      // streetViewControl: false,
      // fullscreenControl: false,
      // rotateControl: false,
      // mapTypeControl: false,
      disableDefaultUI: true,
      clickableIcons: false,
      gestureHandling: 'greedy',
    });
    // initialState.map.addListener(
    //   'dragend',
    //   debounce(_onCenterChanged, 500)
    // );
    initialState.map.addListener(
      'center_changed',
      debounce(_onCenterChanged, 1000)
    );
    initialState.map.addListener('click', _mapOnClick);
    initialState.markerChangedCb = markerChangedCb;
    if (markerDragStartCb) {
      initialState.map.addListener('dragstart', markerDragStartCb);
    }
    const geoCoder = new geocoder();
    const seachCriteria = {};
    if (initialState.placeId) seachCriteria.placeId = initialState.placeId;
    if (position) {
      seachCriteria.location = {
        lat: position?.coords?.latitude,
        lng: position?.coords?.longitude,
      };
    }
    // console.log('Seacrh Criteria: ', seachCriteria);
    geoCoder.geocode(seachCriteria, (results, status) => {
      if (status === OK) {
        try {
          // let addressDetails = getAddressFields(results[0]);
          // console.log('AddresDetails: ', addressDetails);
          // if (addressDetails.pinCode) {
          //   console.log('Setting center: ', results[0].geometry.location);
            initialState.map.setCenter(results[0].geometry.location);
            return resolve(results[0]);
          // }
          // const newLocation = {
          //   location: {
          //     lat: addressDetails.latitude,
          //     lng: addressDetails.longitude,
          //   }
          // };
          // // debugger;
          // geoCoder.geocode(newLocation, (newResults, newStatus) => {
          //   if (newStatus === OK) {
          //     // addressDetails = getAddressFields(newResults[0]);
          //     // console.log('New Address: ', addressDetails);
          //     initialState.map.setCenter(newResults[0].geometry.location);
          //     return resolve(newResults[0]);
          //   }
          // });
        } catch (e) {
          return reject(e);
        }
      } else {
        return reject(results);
      }
    });
  });
};

export const setMapCenter = location => {
  initialState.map.setCenter(location);
};

// const _setMarker = position => {
//   if (initialState.marker) {
//     initialState.marker.setPosition(position);
//   } else {
//     initialState.marker = new marker({
//       map: initialState.map,
//       position: position,
//       icon: upSizedLocationMarker,
//     });
//   }
// };
// const isMapInitialized = () => initialState.isMapInitialized;

export const getPlacePredictions = predictionRequest => {
  return new Promise((resolve, reject) => {
    new gPlaces.AutocompleteService().getPlacePredictions(
      predictionRequest,
      (results, status) => {
        if (status === OK) resolve(results);
        reject(results);
      }
    );
  });
};

export const setPlace = place => {
  initialState.placeId = place.id;
  initialState.geoLocationPosition = null;
};

export const setGeoLocationPosition = position => {
  initialState.geoLocationPosition = position;
  initialState.placeId = null;
};

// export const getPrimaryText = (place = onMarkerChange().results[0]) => {
export const getAddressFields = place => {
  let neighborhood = '';
  let subLocality1 = '';
  let subLocality2 = '';
  let locality = '';
  let city = '';
  let state = '';
  let country = '';
  let pinCode = '';
  // let counter = 0;
  if (place?.address_components) {
    place.address_components.find(ac => {
      // counter++;
      // console.log('counter: ', counter);
      if (ac.types.indexOf('neighborhood') > -1) {
        neighborhood = ac.long_name;
      }
      if (ac.types.indexOf('sublocality_level_1') > -1) {
        subLocality1 = ac.long_name;
      }
      if (ac.types.indexOf('sublocality_level_2') > -1) {
        subLocality2 = ac.long_name;
      }
      if (ac.types.indexOf('locality') > -1) {
        locality = ac.long_name;
      }
      if (ac.types.indexOf('administrative_area_level_2') > -1) {
        city = ac.long_name;
      }
      if (ac.types.indexOf('administrative_area_level_1') > -1) {
        state = ac.long_name;
      }
      if (ac.types.indexOf('country') > -1) {
        country = ac.long_name;
      }
      if (ac.types.indexOf('postal_code') > -1) {
        pinCode = ac.long_name;
      }
      return (
        neighborhood &&
        subLocality1 &&
        subLocality2 &&
        city &&
        country &&
        state &&
        pinCode
      );
    });
  }
  let primaryText = locality;
  if (subLocality2 && subLocality1) {
    primaryText = `${subLocality2}, ${subLocality1}`;
  } else if (subLocality1 || subLocality2) {
    primaryText = subLocality2 || subLocality1;
  }
  if (neighborhood) {
    primaryText = `${neighborhood}, ${primaryText}`;
  }
  const returnObject = {
    primaryText,
    secondaryText: place.formatted_address,
    area: primaryText,
    mapLocation: place.formatted_address,
    addressLine2: place.formatted_address,
    city,
    state,
    country,
    pinCode,
    latitude: config.isApp ? place?.geometry?.location?.lat : place?.geometry?.location?.lat(),
    longitude: config.isApp ? place?.geometry?.location?.lng : place?.geometry?.location?.lng(),
    placeLatitude: place.placeLatitude || null,
    placeLongitude: place.placeLongitude || null,
  };
  return returnObject;
};

// export const getAddressFields = place => getPrimaryText(place);

export const checkLocationPermission = () => {
  if (window.navigator?.permissions?.query) {
    return window.navigator?.permissions?.query({ name: 'geolocation' });
  }
  return Promise.resolve({ state: 'denied' });
};

export const getRecentSearches = () => {
  try {
    const searches = config.LSGetItem('recentSearches');
    if (searches && searches?.length) return searches;
    return [];
  } catch (e) {
    console.log('RecentSearchesFail: ', e);
    return [];
  }
};

// ADC1 Coordinates
export const DEFAULT_LAT = 19.0444404;
export const DEFAULT_LNG = 72.8443776;
export const DEFAULT_COORDS = { latitude: DEFAULT_LAT, longitude: DEFAULT_LNG };
export const GEOLOCATION_TIMEOUT = 2500;
